import React, { useState, useEffect } from 'react';
import { usePopup } from '../../../context/PopupContext';
import PopupPreview from './PopupPreview';

const AutoPopup = () => {
    const { currentPopup, showPopup, closePopup } = usePopup();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (showPopup) {
            setIsVisible(true);
        } else {
            const timer = setTimeout(() => {
                setIsVisible(false);
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [showPopup]);

    if (!currentPopup || !isVisible) {
        return null;
    }

    return (
        <PopupPreview
            isOpen={showPopup}
            onClose={closePopup}
            popup={currentPopup}
        />
    );
};

export default AutoPopup;